<template>
    <v-modal title="Update Sticky Gateway Account" @close="$emit('close')">
        <div v-if="gatewaysOptions" slot="content">
            <div class="grid-content">
                <div class="grid-item grid-item-full">
                    <template v-if="hasOnlyOneGatewayAccount">
                        <p class="stack-m"><span class="inline-s">You have only one Gateway Account</span><b>{{
                            activeGatewayAccountName }}</b></p>
                        <p>To add a new one, visit the
                            <router-link :to="{name:'gateway-accounts'}">Gateway Accounts page</router-link>
                        </p>
                    </template>
                    <v-select
                        v-else
                        label="Select Gateway Account"
                        :options="gatewaysOptions"
                        :show-labels="false"
                        v-model="selectedGatewayAccount"/>
                </div>
            </div>
        </div>
        <template v-if="hasGatewayOptions" slot="actions">
            <r-button type="primary"
                      @click="input"
                      :disabled="hasOnlyOneGatewayAccount">Update
            </r-button>
        </template>
    </v-modal>
</template>

<script>
    import _ from '@/common/helpers';
    import vModal from '@/components/modal/v-modal';
    import {vSelect} from '@/components/form';

    export default {
        name: 'sticky-gateway-modal',
        components: {
            vModal,
            vSelect,
        },
        props: {
            value: {
                type: String,
            },
        },
        data() {
            return {
                selectedGatewayAccount: this.value,
                gatewaysOptions: null,
            };
        },
        computed: {
            hasGatewayOptions() {
                return this.gatewaysOptions && this.gatewaysOptions.length;
            },
            hasOnlyOneGatewayAccount() {
                return this.hasGatewayOptions && this.gatewaysOptions.length === 1;
            },
            activeGatewayAccountName() {
                const {label} = this.gatewaysOptions.find(({value}) => value === this.value) || {};
                return label || this.value;
            },
        },
        methods: {
            close() {
                this.$emit('close');
            },
            input() {
                this.$emit('input', this.selectedGatewayAccount);
            },
            async fetchData() {
                const {items} = await this.$api(({gatewayAccounts}) => gatewayAccounts.getAll());
                this.gatewaysOptions = items.map(
                    ({fields}) => (
                        {
                            label: `${_.truncate(fields.id, {
                                limit: 11,
                                dots: true,
                            })}-${fields.gatewayName}`,
                            value: fields.id,
                        }),
                );
            },
        },
        mounted() {
            this.fetchData();
        },
    };
</script>
